import { Component, OnInit, signal } from '@angular/core'
import { AuthService } from '../../services/auth.service'
import { MapService } from '../../services/map.service'
import { ButtonGroupOption } from '@inst-iot/bosch-angular-ui-components'
import { ThemeMode, ThemeService } from '../../../shared/services/theme.service'

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  standalone: false,
})
export class AccountComponent implements OnInit {
  account = this.authService.activeAccount
  close: any
  isContentVisible: boolean = false
  selectedTheme = signal<ThemeMode>('system')

  themeOptions: ButtonGroupOption[] = [
    { id: 'theme-system', label: 'System', value: 'system' },
    { id: 'theme-light', label: 'Light', value: 'light' },
    { id: 'theme-dark', label: 'Dark', value: 'dark' },
  ]

  constructor(
    private readonly authService: AuthService,
    private readonly mapService: MapService,
    private readonly themeService: ThemeService,
  ) {}

  ngOnInit(): void {
    const persistedTheme = this.themeService.getPersistedThemeMode()
    this.selectedTheme.set(persistedTheme)
    this.mapService.applyMapThemeFromSelection()
  }

  onThemeChange(value: unknown): void {
    const themeMode = this.toThemeMode(value)
    this.selectedTheme.set(themeMode)
    console.log(`Theme changed to: ${themeMode}`)
    this.themeService.setThemeMode(themeMode)
    this.mapService.applyMapThemeFromSelection()
  }

  toggleContent() {
    this.isContentVisible = !this.isContentVisible
  }

  hideContent() {
    this.isContentVisible = false
  }

  logout() {
    this.authService.logout()
  }

  private toThemeMode(value: unknown): ThemeMode {
    return value === 'light' || value === 'dark' || value === 'system' ? value : 'system'
  }
}
